import moment from "moment";
import { PersonService } from "../../core/http/service/PersonService";
import Person from "../../models/core/userRole/Person";

export const FETCH_PERSON = "FETCH_PERSON";
export const FETCH_PERSON_DEPENDENTE = "FETCH_PERSON_DEPENDENTE";
export const ATUALIZA_ACESSO_PRONTUARIO = "ATUALIZA_ACESSO_PRONTUARIO";

const sendToAnalytics = (action: string = "", error: any = null) => {
  console.error(action, error);
};

export const fetchPerson = (personId: string) => {
  const service: PersonService = new PersonService();
  return async (dispatch: any) => {
    try {
      const response: any = await service.getPessoaById(personId);
      const pessoa: Person = new Person().fromJSON(response.data.data);      

      dispatch({
        type: FETCH_PERSON,
        pessoa: pessoa,
      });
    } catch (error: any) {
      sendToAnalytics(error);
      throw error;
    }
  };
};


export const fetchPersonDependente = (personId: string) => {
  const service: PersonService = new PersonService();
  return async (dispatch: any) => {
    try {
      const response: any = await service.getPessoaById(personId);
      const pessoaDependente: Person = new Person().fromJSON(response.data.data);      

      dispatch({
        type: FETCH_PERSON_DEPENDENTE,
        pessoaDependente: pessoaDependente,
      });
    } catch (error: any) {
      sendToAnalytics(error);
      throw error;
    }
  };
};


export const updatePersonInfo = (information: any, personId: string) => {
  const service: PersonService = new PersonService();
  return async (dispatch: any) => {
    try {
      
      const telefones = information.telefone2 !== "" ? [information.telefone1, information.telefone2] : [information.telefone1]

      const person = new Person().fromJSON({
        id: personId,
        nome: information.nomeCompleto,
        comoSerChamado: information.nomeChamado,
        email: information.email,
        cpf: information.cpf,
        dataNascimento:
          information.dataNascimento === ""
            ? null
            : moment(information.dataNascimento).format("YYYY-MM-DD"),
        telefones: telefones,
        contatos: [
          {
            grauParentesco: information.grauParentesco,
            emergencia: true,
            nome: information.nomeContatoUrgencia,
            telefone: information.telefoneUrgencia,
            email: information.emailUrgencia,
          },
        ],
      });
      await service.editPessoaInformation(person);
    } catch (error: any) {
      sendToAnalytics(error);
      throw error;
    }
  };
};

export const uploadPhoto = (photo: any) => {
  const service: PersonService = new PersonService();
  return async (dispatch: any) => {
    try {
      const body = new FormData();
      body.append("file", photo);

      await service.uploadPhoto(body);
    } catch (error: any) {
      sendToAnalytics(error);
      throw error;
    }
  };
};


export const atualizaAcessoProntuario = (valor: boolean) => {
  return async (dispatch: any) => {
    try {

      dispatch({
        type: ATUALIZA_ACESSO_PRONTUARIO,
        acessoProntuario: valor,
      });
    } catch (error: any) {
      sendToAnalytics(error);
      throw error;
    }
  };
};